module.exports = __webpack_public_path__ + "img/IEC30532.bb2fdb1d.png";